import React from 'react';
import styled from '@benzinga/themetron';
import { DelayedQuote } from '@benzinga/quotes-manager';
import { convertToTickerCardQuote, TickerCardQuote, useTickerData } from '@benzinga/ticker-ui';
import { TickerCard } from '@benzinga/ticker-ui';

export interface TickerBoxBlockProps {
  // exchange: string;
  symbol: string;
}

export const TickerBoxBlock: React.FC<TickerBoxBlockProps> = ({
  // exchange,
  symbol,
}) => {
  const { stockQuote } = useTickerData(symbol);
  const tickerCardQuote = convertToTickerCardQuote({
    stockQuote: stockQuote as DelayedQuote,
  }) as TickerCardQuote;
  return (
    <TickerBoxBlockWrapper>
      {tickerCardQuote && tickerCardQuote?.symbol && <TickerCard quote={tickerCardQuote} />}
    </TickerBoxBlockWrapper>
  );
};

export const TickerBoxBlockWrapper = styled.div`
  margin: 2rem 0;
`;
